import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipuriDocumenteComponent } from './tipuri-documente.component';
import { AddTipuriDocumenteComponent } from './add-tipuri-documente/add-tipuri-documente.component';
import { EditTipuriDocumenteComponent } from './edit-tipuri-documente/edit-tipuri-documente.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        TipuriDocumenteComponent,
        AddTipuriDocumenteComponent,
        EditTipuriDocumenteComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [TipuriDocumenteComponent]
})
export class TipuriDocumenteModule { }
